<div class="iiif-wrapper">
  <div class="iiif-container" 
       [style.height.px]="containerHeight"
       [class.dragging]="isDragging"
       #container>

      <div class="loading" *ngIf="loading">
        <span>Loading IIIF images...</span>
      </div>

      <div class="error" *ngIf="error">
        <span>Failed to load image</span>
        <button (click)="reload()">Retry</button>
      </div>

      <ng-container *ngFor="let imageType of imageTypes; let i = index">
        <div class="preview-wrapper" 
             *ngIf="!error && imageType.settings.visible"
             [style.width.px]="displayWidth"
             [style.height.px]="displayHeight"
             [style.transform]="imageTransform"
             [style.transform-origin]="transformOrigin"
             [style.z-index]="i + 1"
             [style.opacity]="imageType.settings.opacity"
             [style.position]="'absolute'"
             [style.top.px]="0"
             [style.left.px]="0">
          <img class="preview-image"
               [src]="imageType.previewUrl"
               (load)="onPreviewLoad(imageType.id)"
               (error)="onPreviewError(imageType.id)"
               [style.opacity]="previewLoaded.get(imageType.id) ? 1 : 0"
               [style.width.px]="displayWidth"
               [style.height.px]="displayHeight"
               [style.object-fit]="'fill'"
               [alt]="alt + ' - ' + imageType.name"/>
        </div>
      
        <div class="image-wrapper" 
             *ngIf="!loading && !error && imageType.settings.visible"
             [style.width.px]="displayWidth"
             [style.height.px]="displayHeight"
             [style.transform]="imageTransform"
             [style.transform-origin]="transformOrigin"
             [style.z-index]="imageTypes.length + i + 1"
             [style.opacity]="imageType.settings.opacity"
             [style.position]="'absolute'"
             [style.top.px]="0"
             [style.left.px]="0">

          <div class="tile" 
               *ngFor="let tile of imageType.tiles; trackBy: trackTile"
               [style.left.px]="tile.x"
               [style.top.px]="tile.y"
               [style.width.px]="tile.width"
               [style.height.px]="tile.height">
            
            <img *ngIf="!tile.error"
                 [src]="tile.url"
                 (load)="onTileLoad(tile)"
                 (error)="onTileError(tile)"
                 class="tile-image"
                 [style.opacity]="tile.loaded ? 1 : 0" />
            
            <div class="tile-error" *ngIf="tile.error">
              <span>✗</span>
            </div>
          </div>
        </div>
      </ng-container>
  </div>

</div>
<div class="control-bar" [class.expanded]="showSettings">
  <div class="control-bar-content">

    <div class="control-group">
      <button (click)="zoomIn()" [disabled]="!canZoomIn" class="control-btn" title="Zoom In">
        <img class="link-icon" src="assets/plus.svg" alt="zoom in Icon" />
      </button>

    
      <span class="control-label">{{ (zoomLevel * 100).toFixed(0) }}%</span>
            <button (click)="zoomOut()" [disabled]="!canZoomOut" class="control-btn" title="Zoom Out">
        <img class="link-icon" src="assets/minus.svg" alt="zoom out Icon" />
      </button>

    </div>
    <div class="control-group">        
      <button (click)="rotateRight()" class="control-btn" title="Rotate Right">
        <img class="link-icon" src="assets/rotate.svg" alt="rotate Icon" />


      </button>

      
      <span class="control-label">{{ rotation }}°</span>
      <button (click)="rotateLeft()" class="control-btn" title="Rotate Left">
        <img class="link-icon" src="assets/rotate-against.svg" alt="rotate Icon" />

      </button>
    </div>

    <button (click)="toggleSettings()" 
            class="btn-adjust"
            [attr.aria-expanded]="showSettings"
            aria-controls="settings-panel"
            [class.active]="showSettings">
            <img class="link-icon" src="assets/search-white-old.svg" alt="search Icon" />
      <span>{{'iaa.app.fragment.adjustImage' | translate}} </span>
    </button>

  </div>

  <!-- Expandable settings panel -->
  <div class="settings-panel" *ngIf="showSettings" id="settings-panel" >
    <div class="settings-panel-content" [attr.dir]="currentLanguage === 'he' ? 'rtl' : 'ltr'">
      <!-- Much simpler: just find each type once and display it -->
      
      <!-- Color (top-left) -->
      <div class="image-control-item" *ngIf="getImageByType('color') as imageType">
        <div class="checkbox-wrapper">
          <label [for]="'check-' + imageType.id" [attr.aria-label]="imageType.ariaLabel">{{ imageType.name }}</label>
          <input type="checkbox" 
                 [id]="'check-' + imageType.id" 
                 [(ngModel)]="imageType.settings.visible"
                 (change)="onVisibilityChanged(imageType)"
                 tabindex="0">
        </div>
        <div class="slider-wrapper">
          <input type="range"
                 min="0" max="1" step="0.05"
                 [value]="imageType.settings.opacity"
                 (input)="onOpacityChanged(imageType, $event)"
                 (mousedown)="$event.stopPropagation()"
                 [disabled]="!imageType.settings.visible"
                 class="range-slider" dir="ltr" tabindex="0">
          <span class="opacity-value">{{ (imageType.settings.opacity * 100).toFixed(0) }}%</span>
        </div>
      </div>

      <!-- Infrared (top-right) -->
      <div class="image-control-item" *ngIf="getImageByType('infrared') as imageType">
        <div class="checkbox-wrapper">
          <label [for]="'check-' + imageType.id" [attr.aria-label]="imageType.ariaLabel">{{ imageType.name }}</label>
          <input type="checkbox" 
                 [id]="'check-' + imageType.id"
                 [(ngModel)]="imageType.settings.visible"
                 (change)="onVisibilityChanged(imageType)"
                 tabindex="0">
        </div>
        <div class="slider-wrapper">
          <input type="range"
                 min="0" max="1" step="0.05"
                 [value]="imageType.settings.opacity"
                 (input)="onOpacityChanged(imageType, $event)"
                 (mousedown)="$event.stopPropagation()"
                 [disabled]="!imageType.settings.visible"
                 class="range-slider" dir="ltr" tabindex="0">
          <span class="opacity-value">{{ (imageType.settings.opacity * 100).toFixed(0) }}%</span>
        </div>
      </div>

      <!-- Raking Left (bottom-left) -->
      <div class="image-control-item" *ngIf="getImageByType('raking-left') as imageType">
        <div class="checkbox-wrapper">
          <label [for]="'check-' + imageType.id" [attr.aria-label]="imageType.ariaLabel">{{ imageType.name }}</label>
          <input type="checkbox" 
                 [id]="'check-' + imageType.id"
                 [(ngModel)]="imageType.settings.visible"
                 (change)="onVisibilityChanged(imageType)"
                 tabindex="0">
        </div>
        <div class="slider-wrapper">
          <input type="range"
                 min="0" max="1" step="0.05"
                 [value]="imageType.settings.opacity"
                 (input)="onOpacityChanged(imageType, $event)"
                 (mousedown)="$event.stopPropagation()"
                 [disabled]="!imageType.settings.visible"
                 class="range-slider" dir="ltr" tabindex="0">
          <span class="opacity-value">{{ (imageType.settings.opacity * 100).toFixed(0) }}%</span>
        </div>
      </div>

      <!-- Raking Right (bottom-right) -->
      <div class="image-control-item" *ngIf="getImageByType('raking-right') as imageType">
        <div class="checkbox-wrapper">
          <label [for]="'check-' + imageType.id" [attr.aria-label]="imageType.ariaLabel">{{ imageType.name }}</label>
          <input type="checkbox" 
                 [id]="'check-' + imageType.id"
                 [(ngModel)]="imageType.settings.visible"
                 (change)="onVisibilityChanged(imageType)"
                 tabindex="0">
        </div>
        <div class="slider-wrapper">
          <input type="range"
                 min="0" max="1" step="0.05"
                 [value]="imageType.settings.opacity"
                 (input)="onOpacityChanged(imageType, $event)"
                 (mousedown)="$event.stopPropagation()"
                 [disabled]="!imageType.settings.visible"
                 class="range-slider" dir="ltr" tabindex="0">
          <span class="opacity-value">{{ (imageType.settings.opacity * 100).toFixed(0) }}%</span>
        </div>
      </div>
    </div>
  </div>
</div>